export default __webpack_public_path__ + "static/media/banner-1.63c65903.jpg";